module.exports = __webpack_public_path__ + "static/media/thumbnail.bc40c194.jpg";